import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[minMaxAmount]'
})
export class MinMaxAmount {
    constructor(private _el: ElementRef) {
    }
    @HostListener('input', ['$event']) onInputChange(event) {
        let initalValue = this._el.nativeElement.value;
        if (this._el.nativeElement.localName == "sirius-textbox" ) {
            initalValue = this._el.nativeElement.children[0].value; 
            if (initalValue > 999000000 || initalValue < 0) {
                if (initalValue > 999000000 )
                    this._el.nativeElement.children[0].value = 999000000;
                else
                    this._el.nativeElement.children[0].value = 0;
                event.stopPropagation();
            }
        }
        else if (this._el.nativeElement.localName == "sirius-numerictextbox") {
            initalValue = this._el.nativeElement.children[0].children[0].children[0].value;
            if (initalValue > 999000000 || initalValue < 0) {
                if (initalValue > 999000000)
                    this._el.nativeElement.children[0].children[0].children[0].value = 999000000;
                else
                    this._el.nativeElement.children[0].children[0].children[0].value = 0;
                event.stopPropagation();
            }
        }
        else { 
            if (initalValue > 999000000 || initalValue < 0) {
                if (initalValue > 999000000)
                    this._el.nativeElement.value = 999000000;
                else
                    this._el.nativeElement.value = 0;
                this._el.nativeElement.value = 0;
                event.stopPropagation();
            }
        }
    } 
   
    @HostListener('paste', ['$event'])
    onPaste(event: Event) {
        setTimeout(() => {
            const input = (<HTMLInputElement>event.target); 
            var inputValue = Number(input.value);
            if (inputValue > 999000000 || inputValue < 0) {
                if (inputValue > 999000000)
                    input.value = '0';
                else
                    input.value = '999000000';
                event.stopPropagation();
            }
        });
    }

}

